import React from "react";
import { createPortal } from "react-dom";
import { Field, INPUT, PRIMARY, SECONDARY } from "../Fields.jsx";
import HoursSummary, { HoursDayRows, HoursSummaryTable, printedPeriod } from "./HoursSummary.jsx";
import { aggregateHours } from "./hoursSummary.js";

export default function HoursPrint({ data, employeeId, onClose }) {
  const { employees, unidentified } = aggregateHours(data.rows);
  const [choice, setChoice] = React.useState(employees.has(employeeId) ? employeeId : "all");
  const dialogRef = React.useRef(null);
  React.useEffect(() => {
    const dialog = dialogRef.current;
    const previous = document.activeElement;
    const previousOverflow = document.body.style.overflow;
    dialog.showModal();
    document.body.style.overflow = "hidden";
    return () => { dialog.close(); document.body.style.overflow = previousOverflow; if (previous?.isConnected) previous.focus({ preventScroll: true }); };
  }, []);
  return createPortal(<dialog ref={dialogRef} className="hours-print-dialog rounded-[4px] border border-slate-300 bg-white text-slate-800" aria-label="Rapport des heures travaillées" onCancel={event => { event.preventDefault(); onClose(); }}>
    <div className="hours-print-toolbar flex flex-wrap items-end gap-2 p-3">
      <Field label="Chauffeur à imprimer"><select className={INPUT} value={choice} onChange={event => setChoice(event.target.value)}><option value="all">Tous les chauffeurs</option>{[...employees.values()].map(employee => <option key={employee.id} value={employee.id}>{employee.name}</option>)}</select></Field>
      <button type="button" className={PRIMARY} onClick={() => window.print()}>Imprimer</button><button type="button" className={SECONDARY} onClick={onClose}>Fermer</button>
    </div>
    <div className="hours-print-pages">
      {[...employees.values()].filter(employee => choice === "all" || choice === employee.id).map(employee => <div className="hours-print-sheet" key={employee.id}><HoursSummary employee={employee} data={data} /></div>)}
      {choice === "all" && unidentified.length ? <section className="hours-print-sheet hours-summary p-3 text-xs" aria-label="Heures non rattachées automatiquement">
        <h3 className="text-sm font-semibold">Heures non rattachées automatiquement</h3><p>{printedPeriod(data)}</p>
        {unidentified.map(row => <div key={row.key}><h4 className="my-2 font-semibold">{row.historical_name || row.employee_name || "Nom indisponible"}</h4><HoursSummaryTable><HoursDayRows row={row} day={row.work_date} timezone={data.timezone} /></HoursSummaryTable></div>)}
      </section> : null}
    </div>
  </dialog>, document.body);
}
